import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=05b87b3e&"
import script from "./AccessControl.vue?vue&type=script&setup=true&lang=js&"
export * from "./AccessControl.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AccessControl.vue?vue&type=style&index=0&id=05b87b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports